import { Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import {
  createCategory,
  handleDeleteCategory,
  handleGetCategory,
  handleUpdateCategory,
} from "../../../services/Category";
import {
  createService,
  deleteService,
  getAllServices,
  getServiceDetails,
  getSingleServicesData,
  updateAllService,
} from "../../../services/Services";
import { categoryValidation } from "../../../utils/Validation";
import NavigationDrawer from "./../../../components/NavigationDrawer/index";
import Categories from "./AddNewCategory";
import Service from "./Service";
import SingleService from "./SingleService";

const tabs = [
  { label: "Services", value: "service" },
  { label: "Categories", value: "newCategory" },
];

function ClientCatalogue() {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.activeTab.tabs);
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  console.log(selectedBranch, "selectedBranchselectedBranch");

  const openCategoryDialog = useRef();
  const [finalValue, setFinalValue] = useState(0);
  const openSerivceDialog = useRef();
  const [isReminderSelected, setIsReminderSelected] = useState(false);
  const [serviceDelete, setServiceDelete] = useState(false);
  const openConfirmDialog = useRef(null);
  const [open, setOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [services, setServices] = useState([]);
  const [editData, setEditData] = useState(null);
  const { user } = useSelector((state) => state.user);
  const [branchId, setBranchId] = useState("");
  const [category, setCategory] = useState([]);
  const [isOnlineBooking, setIsOnlineBooking] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [inputError, setInputError] = useState({
    name: false,
    description: false,
    isValidDes: false,
  });

  const [inputValues, setInputValues] = useState({
    image: null,
    name: "",
    description: "",
    availableFor: "",
    categoryID: "",
    servicesID: "",
    afterCare: "",
    selectedTeam: [],
    selectedService: [],
    duration: "",
    paymentType: "",
    price: "",
    discount: "",
    tax: "",
    extraPerHour: "",
    reminderBefore: "",
    serviceReminder: "",
    reminderMessage: "",
    serviceDiscription: "",
  });

  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  useEffect(() => {
    if (editData && editData?.type !== "add" && editData?.page == "service") {
      handleFetchServiceDetail(editData);
    }
  }, [editData]);

  useEffect(() => {
    if (selectedBranch?.length == 1) {
      handleFetchCategory();
      handleFetchAllServices();
    }
  }, [selectedBranch, activeTab]);

  const handleFetchServiceDetail = async (data) => {
    try {
      setIsLoading(true);
      const responce = await getServiceDetails(data?._id);
      setIsLoading(false);
      if (responce.status == 200 || responce.status == 201) {
        let data = responce?.data?.data;
        setBranchId(data?.branchId?._id);

        setInputValues({
          name: data?.serviceName,
          description: data?.serviceDescription,
          categoryID: data?.categoryId?._id,
          availableFor: data?.serviceAvailability,
          afterCare: data?.afterCareDescription,
          selectedTeam: data?.teamMembers,
          duration: data?.duration,
          paymentType: data?.priceType,
          price: data?.actualPrice,
          discount: data?.discount,
          reminderBefore: data?.notificationReminderTime,
          reminderMessage: data?.notificationReminderMessage,
          extraPerHour: data?.extraPerHour,
          tax: data?.tax,
        });
        setImages(data?.images);

        if (data?.notificationReminderTime) {
          setIsReminderSelected(true);
        } else {
          setIsReminderSelected(false);
        }
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleFetchAllBranches ~ error:", error);
      handleSnackbarVal(true, "error", error?.data?.message);
    }
  };

  const handleBack = (tabName) => {
    setInputValues({
      name: "",
      description: "",
      categoryID: "",
      availableFor: "",
      afterCare: "",
      selectedTeam: "",
      duration: "",
      paymentType: "",
      price: "",
      discount: "",
      reminderBefore: "",
      reminderMessage: "",
    });
    setImages([]);
    setIsOnlineBooking(false);
    setIsReminderSelected(false);
    handleChangeTab(tabName);
  };

  const handleFetchCategory = async () => {
    try {
      setIsLoading(true);
      const responce = await handleGetCategory(
        selectedBranch,
        user?.businessId
      );
      setIsLoading(false);
      if (responce?.status == 200 || responce?.status == 201) {
        let data = responce?.data?.data;
        console.log(data, "datadatadatadata");

        setCategory(data);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleFetchCategory ~ error:", error);
      handleSnackbarVal(true, "error", error?.data?.message);
    }
  };

  const handleFetchAllServices = async () => {
    try {
      setIsLoading(true);
      const responce = await getAllServices(selectedBranch);
      setIsLoading(false);
      if (responce?.status == 200 || responce?.status == 201) {
        let data = responce?.data?.data;
        console.log(data, "datadatadata");
        setServices(data);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleFetchCategory ~ error:", error);
      handleSnackbarVal(true, "error", error?.data?.message);
    }
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleEdit = (item) => {
    openCategoryDialog.current.isVisible({ type: "edit", data: item });
  };

  const handleDelete = async (item) => {
    openConfirmDialog.current.isVisible({ data: item });
  };

  const handleAddCategory = () => {
    openCategoryDialog.current.isVisible({ type: "add", data: {} });
  };

  const handleAddEditCategory = async (data) => {
    let item = data?.data;
    try {
      const valid = categoryValidation(inputValues, setInputError);
      if (!valid) {
        let payload = {
          name: inputValues.name,
          branchId: selectedBranches,
          businessId: user?.businessId,
        };

        let params = {
          name: inputValues.name,
          branchId: item?.branchId?._id,
          businessId: user?.businessId,
        };
        if (selectedBranches?.length == 0) {
          return handleSnackbarVal(
            true,
            "error",
            "please select at least one branch"
          );
        }
        setIsLoading(true);
        const response =
          data?.type === "edit"
            ? await handleUpdateCategory(item?._id, params)
            : await createCategory(payload);
        setIsLoading(false);

        if (response.status === 200 || response.status === 201) {
          handleSnackbarVal(true, "success", response?.data?.message);
          handleFetchCategory();
          setSelectedBranches([]);
        } else {
          setSelectedBranches([]);
          handleSnackbarVal(true, "error", response?.data?.message);
        }
        handleClose();
      }
    } catch (error) {
      setIsLoading(false);
      handleSnackbarVal(
        true,
        "error",
        error?.response?.data?.message || "An error occurred"
      );
      console.error("Error saving category:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value, "NAMEEEEE");

    setInputValues({
      ...inputValues,
      [name]: value,
    });
  };

  const handleClose = () => {
    setOpen(false);
    setInputValues({
      image: null,
      name: "",
      description: "",
    });
    setInputError({});
  };

  const handleConfirm = async (item) => {
    console.log(item, "itemitemitem");

    try {
      setIsLoading(true);
      const responce = await handleDeleteCategory(item?.data?._id);
      handleSnackbarVal(true, "success", responce?.data?.message);
      handleFetchCategory();
      setIsLoading(false);
      setOpenConfirm(false);
    } catch (error) {
      console.log("🚀 ~ handleDelete ~ error:", error);
    }
  };

  const handleServiceDeleteConfirm = async ({ row }) => {
    console.log(row, "rowrowrowrow");

    try {
      setIsLoading(true);
      const responce = await deleteService(row?._id);
      setIsLoading(false);
      if (responce.status == 200 || responce.status == 201) {
        handleSnackbarVal(true, "success", responce?.data?.message);
        handleFetchCategory();
        handleFetchAllServices();
        setServiceDelete(false);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      handleSnackbarVal(true, "error", error?.data?.message);
      console.log("🚀 ~ handleDelete ~ error:", error);
    }
  };

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, clientCatalogue: tab }));
  };

  const handleServiceEdit = (row) => {
    setEditData({ ...row, type: "edit", page: "service" });
    handleChangeTab("singleService");
  };

  const handleSelectMenu = ({ tab, data }) => {
    setEditData(data);
    if (tab === "single") {
      handleChangeTab("singleService");
    }
    if (tab === "newPackage") {
      handleChangeTab("addNewPackage");
    }
  };

  const handleCreateService = async (data) => {
    const item = await data?.type;

    const {
      name,
      description,
      categoryID,
      afterCare,
      duration,
      tax,
      discount,
      reminderBefore,
      reminderMessage,
      price,
    } = inputValues;

    try {
      let missingFields = [];
      if (!name) missingFields.push("Service Name");
      if (!description) missingFields.push("Service Description");
      if (!categoryID) missingFields.push("Category ID");
      if (!afterCare) missingFields.push("After Care");
      if (!duration) missingFields.push("Duration");
      if (!price) missingFields.push("Service Price");

      if (missingFields.length > 0) {
        return handleSnackbarVal(
          true,
          "error",
          `Please fill in the following required fields: ${missingFields.join(
            ", "
          )}`
        );
      } else {
        let payload = {
          serviceName: name,
          serviceCategoryID: categoryID,
          categoryId: categoryID,
          businessId: user?.businessId,
          branchId: item !== "edit" ? selectedBranch : branchId,
          serviceDescription: description,
          afterCareDescription: afterCare,
          duration: duration,
          price: Number(finalValue),
          tax: Number(tax),
          discount: discount,
          notificationReminderTime: Number(reminderBefore),
          notificationReminderMessage: reminderMessage,
        };
        setIsLoading(true);
        const responce =
          item !== "edit"
            ? await createService({
                actualPrice: Number(price),
                ...payload,
              })
            : await updateAllService(data?._id, payload);
        setIsLoading(false);
        if (responce.status === 200 || responce.status === 201) {
          handleSnackbarVal(true, "success", responce?.data?.message);
          handleFetchAllServices();
          handleBack("service");
        } else {
          handleSnackbarVal(true, "error", responce?.data?.message);
        }
      }
    } catch (error) {
      setIsLoading(false);
      handleSnackbarVal(
        true,
        "error",
        error?.response?.data?.message || "An error occurred"
      );
      console.error("Error saving category:", error);
    }
  };

  const handleChangeStatus = async (row, index) => {
    let payload = {
      status: row?.status,
    };
    const responce = await updateAllService(row?._id, payload);
    if (responce.status == 200 || responce?.status == 201) {
      handleSnackbarVal(true, "success", responce?.data?.message);
      handleFetchAllServices();
    } else {
      handleSnackbarVal(true, "error", responce?.data?.message);
    }
    try {
    } catch (error) {
      console.log(error, "errorerrorerrorerrorerror");
    }
  };

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"Catalogue*"}
            tabs={tabs}
            activeTab={activeTab.clientCatalogue}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.clientCatalogue === "service" ? (
            <Service
              handleSelect={handleSelectMenu}
              services={services}
              handleDelete={(row) => {
                openSerivceDialog.current.isVisible({ row });
              }}
              openConfirm={serviceDelete}
              handleChangeStatus={handleChangeStatus}
              setOpenConfirm={setServiceDelete}
              openConfirmDialog={openSerivceDialog}
              handleConfirm={handleServiceDeleteConfirm}
              editData={editData}
              handleEdit={handleServiceEdit}
            />
          ) : activeTab.clientCatalogue === "singleService" ? (
            <SingleService
              editData={editData}
              category={category}
              setImages={setImages}
              finalValue={finalValue}
              inputValue={inputValues}
              setFinalValue={setFinalValue}
              handleInputChange={handleInputChange}
              handleBack={() => handleBack("service")}
              isReminderSelected={isReminderSelected}
              setIsReminderSelected={setIsReminderSelected}
              handleCreateService={handleCreateService}
            />
          ) : activeTab.clientCatalogue === "newCategory" ? (
            <Categories
              open={open}
              setOpen={setOpen}
              handleChageInputs={handleInputChange}
              handleClose={handleClose}
              handleAddEditCategory={handleAddEditCategory}
              setInputValues={setInputValues}
              handleDelete={handleDelete}
              handleAddCategory={handleAddCategory}
              handleEdit={handleEdit}
              selectedBranches={selectedBranches}
              setSelectedBranches={setSelectedBranches}
              setOpenConfirm={setOpenConfirm}
              handleConfirm={handleConfirm}
              category={category}
              openCategoryDialog={openCategoryDialog}
              inputError={inputError}
              openConfirm={openConfirm}
              inputValues={inputValues}
              openConfirmDialog={openConfirmDialog}
            />
          ) : null}
        </Grid>
      </Grid>
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
    </NavigationDrawer>
  );
}

export default ClientCatalogue;

const asdas = {
  serviceName: "test",
  serviceCategoryID: "67db07fb9fac94c8e9b9dcd5",
  categoryId: "67db07fb9fac94c8e9b9dcd5",
  businessId: "67d1d749f15a204ceab8286c",
  branchId: ["67db03e49fac94c8e9b9dc82"],
  serviceDescription: "test",
  afterCareDescription: "test",
  images: [],
  isOnline: true,
  duration: "120",
  extraPerHour: 0,
  price: 190,
  tax: 10,
  discount: "15",
  notificationReminderTime: 60,
  notificationReminderMessage: "test",
};
